/**
 * Bed Finder quiz — logic ported from sleepco-quiz-v4.jsx
 * Initializes each [data-bed-finder] root; reads JSON config from .bed-finder__config
 */
(function () {
  'use strict';

  var DEFAULT_Q = {
    room: {
      id: 'room',
      q: 'Which room are you\nshopping for?',
      options: [
        { v: 'master', label: 'Master bedroom', sub: 'Your primary sleep sanctuary' },
        { v: 'guest', label: 'Guest bedroom', sub: 'Welcoming, considered, practical' },
        { v: 'child', label: "Child or teen's room", sub: 'Built to last as they grow' },
        { v: 'unsure', label: 'Not decided yet', sub: "We'll help you figure it out" },
      ],
    },
    product_type: {
      id: 'product_type',
      q: 'What are you\nlooking to buy?',
      hint: 'Choose one option — you can run the quiz again if you need both.',
      options: [
        { v: 'frame', label: 'A bed frame', sub: 'Upholstered, handcrafted in the UK' },
        { v: 'mattress', label: 'A mattress', sub: 'Engineered for deep, restorative sleep' },
        { v: 'sofa', label: 'A sofa bed', sub: 'Space-smart without compromise' },
        { v: 'help', label: 'Help me decide', sub: "We'll guide you through it" },
      ],
    },
    existing_mattress: {
      id: 'existing_mattress',
      q: 'Do you already have a\nmattress to keep?',
      hint: 'This determines which bases are technically compatible with your mattress.',
      options: [
        { v: 'no', label: 'No — I need a new mattress', sub: "We'll match frame and mattress together" },
        { v: 'yes_standard', label: 'Standard mattress', sub: 'High-street or mid-range brand' },
        { v: 'yes_premium', label: 'Premium mattress', sub: 'Vispring, Hypnos, Savoir, Hästens, Simba or similar' },
      ],
    },
    storage: {
      id: 'storage',
      q: 'Do you need\nstorage?',
      hint: 'Our ottoman bases offer 30cm of hidden storage — the deepest available in the UK.',
      options: [
        { v: 'none', label: 'No storage needed', sub: 'Clean lines, maximum simplicity' },
        { v: 'ottoman', label: 'Ottoman hidden storage', sub: '30cm below — invisible from above' },
        { v: 'drawers', label: 'Side drawers', sub: 'Accessible everyday storage' },
        { v: 'unsure', label: 'Show me the difference', sub: "We'll explain both options" },
      ],
    },
    ottoman_type: {
      id: 'ottoman_type',
      q: 'How would you like\nto lift the base?',
      hint: 'Gas pistons are calibrated precisely to your mattress weight. Free swap service included.',
      options: [
        { v: 'manual', label: 'Manual lift', sub: 'Simple, reliable — no power required' },
        { v: 'electric', label: 'Electric lift', sub: 'OKIN German motors — one touch, effortless' },
      ],
    },
    adjustable: {
      id: 'adjustable',
      q: 'Do you need adjustable\nsleep positions?',
      hint: 'Each partner adjusts head and legs independently — ideal for snoring, reflux, or reading.',
      options: [
        { v: 'yes', label: 'Yes, this matters to me', sub: 'Head and leg positions, individually controlled' },
        { v: 'no', label: 'A flat base is fine', sub: 'Standard platform, full mattress support' },
      ],
    },
    base_upgrade: {
      id: 'base_upgrade',
      q: 'Platform or\nsprung slats?',
      hint: 'All Sleep Co beds come with a solid platform base as standard — no gaps over 7cm, fully compatible with every premium mattress manufacturer.',
      options: [
        { v: 'platform', label: 'Platform base', sub: 'Solid, no slats, premium mattress safe — standard' },
        { v: 'sprung', label: 'Sprung slats', sub: 'Added flex, refined visual finish — upgrade' },
      ],
    },
    size: {
      id: 'size',
      q: 'What size do\nyou need?',
      hint: 'A king is 150cm wide. A super king is 180cm.',
      options: [
        { v: 'small_single', label: 'Small Single', sub: '75cm' },
        { v: 'single', label: 'Single', sub: '90cm' },
        { v: 'small_double', label: 'Small Double', sub: '120cm' },
        { v: 'double', label: 'Double', sub: '135cm' },
        { v: 'king', label: 'King', sub: '150cm' },
        { v: 'super_king', label: 'Super King', sub: '180cm' },
      ],
    },
    mattress_feel: {
      id: 'mattress_feel',
      q: 'What feel are\nyou looking for?',
      hint: 'Every mattress handcrafted in the UK. 7-year guarantee as standard.',
      options: [
        { v: 'soft', label: 'Soft', sub: 'Pillow top comfort — cradling and plush' },
        { v: 'medium', label: 'Medium', sub: 'Balanced support — our most popular feel' },
        { v: 'firm', label: 'Firm', sub: 'Postural support — structured and precise' },
        { v: 'cool', label: 'Cooling', sub: 'Gel hybrid layers — temperature regulated' },
        { v: 'natural', label: 'Natural', sub: 'Latex, wool, organic — breathable' },
      ],
    },
    budget: {
      id: 'budget',
      q: "What's your\nframe budget?",
      hint: 'Every tier is handcrafted in the UK with a 15-year guarantee and white glove delivery.',
      options: [
        { v: 'entry', label: 'Up to £1,000', sub: 'Entry range — Aria, Oxy, Lory' },
        { v: 'mid', label: '£1,000 – £2,500', sub: 'Core collection — widest choice' },
        { v: 'premium', label: '£2,500 – £4,000', sub: 'Premium bespoke builds' },
        { v: 'luxury', label: '£4,000+', sub: 'Full luxury commission' },
        { v: 'open', label: 'Flexible budget', sub: 'Show me the full range' },
      ],
    },
    priorities: {
      id: 'priorities',
      q: 'What matters\nmost to you?',
      hint: 'Choose the one that matters most.',
      options: [
        { v: 'style', label: 'Style & aesthetics', sub: 'Design-led, considered, distinctive' },
        { v: 'storage', label: 'Storage', sub: 'Practical hidden space' },
        { v: 'health', label: 'Health & mobility', sub: 'Support, positioning, wellbeing' },
        { v: 'quality', label: 'British craftsmanship', sub: 'Built to last decades' },
        { v: 'space', label: 'Space saving', sub: 'Maximising smaller rooms' },
        { v: 'value', label: 'Value for money', sub: 'Quality without excess' },
      ],
    },
  };

  var LABELS = {
    room: { master: 'Master bedroom', guest: 'Guest bedroom', child: "Child / teen's room", unsure: 'TBC' },
    product_type: { frame: 'Bed frame', mattress: 'Mattress only', sofa: 'Sofa bed', help: 'Guided' },
    existing_mattress: { no: 'New mattress needed', yes_standard: 'Standard mattress', yes_premium: 'Premium mattress' },
    storage: { none: 'No storage', ottoman: 'Ottoman storage', drawers: 'Drawer storage', unsure: 'TBC' },
    ottoman_type: { manual: 'Manual lift', electric: 'Electric lift' },
    adjustable: { yes: 'Yes', no: 'No' },
    base_upgrade: { platform: 'Platform base', sprung: 'Sprung slats' },
    size: {
      small_single: 'Small Single',
      single: 'Single',
      small_double: 'Small Double',
      double: 'Double',
      king: 'King',
      super_king: 'Super King',
    },
    mattress_feel: { soft: 'Soft', medium: 'Medium', firm: 'Firm', cool: 'Cooling', natural: 'Natural' },
    budget: { entry: 'Up to £1,000', mid: '£1,000–£2,500', premium: '£2,500–£4,000', luxury: '£4,000+', open: 'Flexible' },
    priorities: {
      style: 'Style & aesthetics',
      storage: 'Storage',
      health: 'Health & mobility',
      quality: 'British craftsmanship',
      space: 'Space saving',
      value: 'Value for money',
    },
  };

  function normalizeProductTypes(ans) {
    var v = ans.product_type;
    if (v == null || v === '') return [];
    if (Array.isArray(v)) return v.filter(Boolean);
    return [v];
  }

  /** Single-select in UI; still accepts legacy array answers. */
  function normalizePriorities(ans) {
    var p = ans.priorities;
    if (p == null || p === '') return [];
    if (Array.isArray(p)) return p.filter(Boolean);
    return [p];
  }

  function wipeDownstreamOfProductType(ans) {
    ['existing_mattress', 'storage', 'ottoman_type', 'adjustable', 'base_upgrade', 'size', 'mattress_feel', 'budget', 'priorities'].forEach(function (k) {
      delete ans[k];
    });
  }

  function buildFlow(ans) {
    var flow = ['room', 'product_type'];
    var types = normalizeProductTypes(ans);
    if (types.length === 0) return flow;

    var hasSofa = types.indexOf('sofa') !== -1;
    var hasMattress = types.indexOf('mattress') !== -1;
    var hasBedShop = types.indexOf('frame') !== -1 || types.indexOf('help') !== -1;

    if (hasSofa && !hasMattress && !hasBedShop) {
      return flow.concat(['size']);
    }
    if (hasMattress && !hasBedShop) {
      return flow.concat(['mattress_feel', 'size']);
    }

    if (hasMattress) flow.push('mattress_feel');

    flow.push('existing_mattress');
    var em = ans.existing_mattress;
    if (!em) return flow;
    flow.push('storage');
    var st = ans.storage;
    if (!st) return flow;
    if (st === 'ottoman' || st === 'unsure') flow.push('ottoman_type');
    else if (st === 'none') {
      flow.push('adjustable');
      if (ans.adjustable === 'no') flow.push('base_upgrade');
    } else if (st === 'drawers') flow.push('base_upgrade');
    flow.push('size', 'budget', 'priorities');
    return flow;
  }

  function recommend(ans) {
    var types = normalizeProductTypes(ans);
    var hasSofa = types.indexOf('sofa') !== -1;
    var hasMattress = types.indexOf('mattress') !== -1;
    var hasBedShop = types.indexOf('frame') !== -1 || types.indexOf('help') !== -1;

    var existing_mattress = ans.existing_mattress;
    var storage = ans.storage;
    var ottoman_type = ans.ottoman_type;
    var adjustable = ans.adjustable;
    var mattress_feel = ans.mattress_feel;
    var budget = ans.budget;
    var hasPremium = existing_mattress === 'yes_premium';
    var isEntry = budget === 'entry';

    var mattressMap = {
      soft: {
        name: 'Pillow Top Range',
        path: '/collections/pillow-top-range-mattresses',
        note: 'Sumptuous comfort layer over a pocket spring core.',
      },
      medium: {
        name: 'Lumna Sleep Range',
        path: '/collections/lumna-sleep-range',
        note: 'Our best-selling balanced feel. 1000-count pocket springs.',
      },
      firm: {
        name: 'Lumna Sleep Range — Firm',
        path: '/collections/lumna-sleep-range',
        note: 'Firm tension, engineered for correct spinal alignment.',
      },
      cool: {
        name: 'Gel Hybrid Range',
        path: '/collections/gel-hybrid-range',
        note: 'Gel-infused layers regulate temperature as you sleep.',
      },
      natural: {
        name: 'Natural Mattress Collection',
        path: '/collections/natural-mattresses',
        note: 'FSC-certified fillings. Breathable and hypoallergenic.',
      },
    };

    if (hasSofa && !hasMattress && !hasBedShop) {
      return {
        tag: 'SOFA BED',
        headline: 'Our handcrafted\nsofa bed collection',
        desc: 'Space-smart and beautifully upholstered. Built to the same standard as every Sleep Co bed — perfect for rooms that need to work harder.',
        path: '/collections/sofa-beds',
        exclusion: null,
        platformNote: null,
      };
    }

    if (hasMattress && hasBedShop && !hasSofa) {
      var mCombo = mattressMap[mattress_feel] || mattressMap.medium;
      return {
        tag: 'BED & MATTRESS',
        headline: mCombo.name + '\n& upholstered frames',
        desc:
          mCombo.note +
          ' Handcrafted in the UK with a 7-year mattress guarantee. Pair with a Sleep Co frame — solid platform base, 15-year guarantee, white glove delivery.',
        path: '/collections/bed-frames',
        exclusion: hasPremium && isEntry ? 'entry' : null,
        platformNote: hasPremium ? 'premium' : 'standard',
      };
    }

    if (hasMattress && !hasBedShop) {
      var m = mattressMap[mattress_feel] || mattressMap.medium;
      return {
        tag: 'MATTRESS',
        headline: m.name,
        desc: m.note + ' Handcrafted in the UK. 7-year guarantee.',
        path: m.path,
        exclusion: null,
        platformNote: null,
      };
    }

    if (adjustable === 'yes')
      return {
        tag: 'ADJUSTABLE BED',
        headline: 'Adjustable beds —\npersonalised sleep',
        desc: 'Dual OKIN German motors. Each partner adjusts head and legs independently. Available as a complete set with mattress. Ideal for mobility, snoring, and reflux. 15-year guarantee.',
        path: '/products/essential-adjustable',
        exclusion: null,
        platformNote: null,
      };
    if (storage === 'ottoman' || storage === 'unsure') {
      if (ottoman_type === 'electric')
        return {
          tag: 'ELECTRIC OTTOMAN',
          headline: 'Powered Ottoman —\nthe touch of a button',
          desc: 'OKIN German motors. Gas pistons calibrated to your mattress weight — free swap included. 30cm hidden storage. 250kg SATRA-certified weight rating. 15-year guarantee.',
          path: '/collections/ottoman-storage-beds',
          exclusion: hasPremium && isEntry ? 'entry' : null,
          platformNote: hasPremium ? 'premium' : 'standard',
        };
      return {
        tag: isEntry && !hasPremium ? 'ENTRY OTTOMAN' : 'MANUAL OTTOMAN',
        headline: hasPremium && isEntry ? 'Our premium ottoman range' : 'Manual Ottoman collection',
        desc:
          isEntry && !hasPremium
            ? 'Aria, Oxy, and Lory from £699. Gas-piston lift. 30cm storage. 250kg weight rating. Signature Sleep Co quality at an accessible price.'
            : 'Gas-piston lift. 30cm hidden storage. Side or end lift. 250kg SATRA-certified. Over 100 luxury fabrics. 15-year guarantee.',
        path: '/collections/ottoman-storage-beds',
        exclusion: hasPremium && isEntry ? 'entry' : null,
        platformNote: hasPremium ? 'premium' : 'standard',
      };
    }
    var sz = (ans.size || '').replace(/_/g, ' ').replace(/\b\w/g, function (c) {
      return c.toUpperCase();
    });
    var withDrawers = storage === 'drawers';
    return {
      tag: withDrawers ? 'STORAGE BED' : 'BED FRAME',
      headline:
        isEntry && !hasPremium
          ? 'Entry range —\nAria, Oxy & Lory'
          : (sz ? sz + '\n' : '') + (withDrawers ? 'Upholstered storage bed' : 'Upholstered bed frame'),
      desc:
        isEntry && !hasPremium
          ? 'Aria, Oxy, and Lory — from £699. The same handcrafted quality, 15-year guarantee, and white glove delivery.'
          : 'Handcrafted in the UK. Solid platform base as standard. Over 100 luxury fabrics. 15-year guarantee. Complimentary white glove delivery and assembly.',
      path: withDrawers ? '/collections/ottoman-storage-beds' : '/collections/bed-frames',
      exclusion: hasPremium && isEntry ? 'entry' : null,
      platformNote: hasPremium ? 'premium' : 'standard',
    };
  }

  function cloneQ(base) {
    return JSON.parse(JSON.stringify(base));
  }

  function applyConfig(Q, cfg) {
    if (!cfg) return Q;
    function applyStepCopy(sc, sid) {
      if (!Q[sid]) return;
      if (sc.q) Q[sid].q = String(sc.q).replace(/<br\s*\/?>/gi, '\n');
      if (sc.hint !== undefined && sc.hint !== '') Q[sid].hint = String(sc.hint).replace(/<br\s*\/?>/gi, '\n');
      if (sc.hint === '') delete Q[sid].hint;
    }
    if (cfg.stepCopy && typeof cfg.stepCopy === 'object' && !Array.isArray(cfg.stepCopy)) {
      Object.keys(cfg.stepCopy).forEach(function (sid) {
        applyStepCopy(cfg.stepCopy[sid], sid);
      });
    }
    if (cfg.stepCopyList && cfg.stepCopyList.length) {
      cfg.stepCopyList.forEach(function (item) {
        if (item && item.step) applyStepCopy(item, item.step);
      });
    }
    if (cfg.optionOverrides && cfg.optionOverrides.length) {
      cfg.optionOverrides.forEach(function (o) {
        var step = Q[o.step];
        if (!step || !step.options) return;
        var opt = null;
        for (var oi = 0; oi < step.options.length; oi++) {
          if (step.options[oi].v === o.value) {
            opt = step.options[oi];
            break;
          }
        }
        if (opt) {
          if (o.label) opt.label = o.label;
          if (o.sub) opt.sub = o.sub;
        }
      });
    }
    return Q;
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  /** Optional higher weight for high-signal dimensions (size, budget, type). */
  var TAG_WEIGHTS = {
    master: 1,
    guest: 1,
    child: 1,
    bedframe: 1.5,
    sofabed: 1.5,
    mattress: 1.5,
    standardmattress: 1.25,
    premiummattress: 1.25,
    nostorage: 1.25,
    ottomanstorage: 1.25,
    sidedrawers: 1.25,
    manualottoman: 1,
    electricottoman: 1,
    adjustable: 1.25,
    flatbase: 1,
    smallsingle: 2,
    single: 2,
    smalldouble: 2,
    double: 2,
    king: 2,
    superking: 2,
    entrybudget: 1.5,
    corebudget: 1.5,
    premiumbudget: 1.5,
    luxurybudget: 1.5,
    stylematter: 1,
    storagematter: 1,
    healthmatter: 1,
    spacematter: 1,
    valuematter: 1,
  };

  /**
   * Map quiz answers → canonical tag list (deduped).
   * Taxonomy must match product tags in Shopify (see theme section docs).
   */
  function answersToQuizTags(ans) {
    var raw = [];
    var roomMap = { master: 'master', guest: 'guest', child: 'child' };
    if (ans.room && roomMap[ans.room]) raw.push(roomMap[ans.room]);

    var types = normalizeProductTypes(ans);
    for (var ti = 0; ti < types.length; ti++) {
      var p = types[ti];
      if (p === 'frame') raw.push('bedframe');
      if (p === 'mattress') raw.push('mattress');
      if (p === 'sofa') raw.push('sofabed');
      if (p === 'help') raw.push('bedframe');
    }

    if (ans.existing_mattress === 'yes_standard') raw.push('standardmattress');
    if (ans.existing_mattress === 'yes_premium') raw.push('premiummattress');

    var storageMap = {
      none: 'nostorage',
      ottoman: 'ottomanstorage',
      drawers: 'sidedrawers',
      unsure: 'ottomanstorage',
    };
    if (ans.storage && storageMap[ans.storage]) raw.push(storageMap[ans.storage]);

    if (ans.ottoman_type === 'manual') raw.push('manualottoman');
    if (ans.ottoman_type === 'electric') raw.push('electricottoman');

    if (ans.adjustable === 'yes') raw.push('adjustable');
    if (ans.adjustable === 'no') raw.push('flatbase');

    if (ans.base_upgrade === 'platform') raw.push('flatbase');

    var sizeMap = {
      small_single: 'smallsingle',
      single: 'single',
      small_double: 'smalldouble',
      double: 'double',
      king: 'king',
      super_king: 'superking',
    };
    if (ans.size && sizeMap[ans.size]) raw.push(sizeMap[ans.size]);

    var budgetMap = {
      entry: 'entrybudget',
      mid: 'corebudget',
      premium: 'premiumbudget',
      luxury: 'luxurybudget',
    };
    if (ans.budget && budgetMap[ans.budget]) raw.push(budgetMap[ans.budget]);

    var prList = normalizePriorities(ans);
    if (prList.length) {
      var prMap = {
        style: 'stylematter',
        storage: 'storagematter',
        health: 'healthmatter',
        space: 'spacematter',
        value: 'valuematter',
        quality: 'stylematter',
      };
      for (var pi = 0; pi < prList.length; pi++) {
        var pr = prList[pi];
        if (prMap[pr]) raw.push(prMap[pr]);
      }
    }

    var seen = {};
    var out = [];
    for (var ri = 0; ri < raw.length; ri++) {
      var tag = raw[ri];
      if (tag == null || tag === '' || seen[tag]) continue;
      seen[tag] = true;
      out.push(tag);
    }
    return out;
  }

  function productTagsNormalized(product) {
    var tags = product.tags || [];
    if (typeof tags === 'string') {
      tags = tags.split(',').map(function (x) {
        return x.trim();
      });
    } else if (tags && typeof tags === 'object' && !Array.isArray(tags)) {
      var okeys = Object.keys(tags);
      var arrayLike =
        okeys.length > 0 &&
        okeys.every(function (k) {
          return /^\d+$/.test(k);
        });
      if (arrayLike) {
        tags = okeys
          .sort(function (a, b) {
            return Number(a) - Number(b);
          })
          .map(function (k) {
            return tags[k];
          })
          .filter(function (x) {
            return x != null && x !== '';
          });
      } else {
        tags = [];
      }
    }
    if (!Array.isArray(tags)) tags = [];
    var out = [];
    var seen = {};
    for (var i = 0; i < tags.length; i++) {
      var n = String(tags[i]).trim();
      if (!n || seen[n]) continue;
      seen[n] = true;
      out.push(n);
    }
    return out;
  }

  function scoreProductForQuiz(ptags, wantedTags) {
    var pset = {};
    for (var i = 0; i < ptags.length; i++) pset[ptags[i]] = true;

    var score = 0;
    var matches = 0;
    for (var w = 0; w < wantedTags.length; w++) {
      var t = wantedTags[w];
      if (pset[t]) {
        var tw = TAG_WEIGHTS[t] != null ? TAG_WEIGHTS[t] : 1;
        score += tw;
        matches += 1;
      }
    }

    var penalty = 0;
    var wantNone = wantedTags.indexOf('nostorage') !== -1;
    if (wantNone) {
      if (pset.ottomanstorage) penalty += 4;
      if (pset.sidedrawers) penalty += 4;
    }
    var wantStandard = wantedTags.indexOf('standardmattress') !== -1;
    var wantPremium = wantedTags.indexOf('premiummattress') !== -1;
    if (wantStandard && pset.premiummattress && !wantPremium) penalty += 2;
    if (wantPremium && pset.standardmattress && !wantStandard) penalty += 2;

    var wantManual = wantedTags.indexOf('manualottoman') !== -1;
    var wantElectric = wantedTags.indexOf('electricottoman') !== -1;
    if (wantManual && !wantElectric && pset.electricottoman) penalty += 1;
    if (wantElectric && !wantManual && pset.manualottoman) penalty += 1;

    score = score - penalty;
    return { score: score, matches: matches };
  }

  function rankProductsByTags(products, wantedTags, maxCount) {
    var max = maxCount > 0 ? maxCount : 6;
    if (!products || !products.length) {
      return { ranked: [], usedPositiveOnly: false };
    }
    if (!wantedTags || !wantedTags.length) {
      var sorted = products.slice().sort(function (a, b) {
        return String(a.title || '').localeCompare(String(b.title || ''));
      });
      return { ranked: sorted.slice(0, max), usedPositiveOnly: false };
    }

    var scored = [];
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var pt = productTagsNormalized(p);
      var r = scoreProductForQuiz(pt, wantedTags);
      scored.push({ product: p, score: r.score, matches: r.matches });
    }

    scored.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      if (b.matches !== a.matches) return b.matches - a.matches;
      return String(a.product.title || '').localeCompare(String(b.product.title || ''));
    });

    var positive = scored.filter(function (s) {
      return s.score > 0;
    });
    var pool = positive.length ? positive : scored;
    var usedPositiveOnly = positive.length > 0;

    return {
      ranked: pool.slice(0, max).map(function (s) {
        return s.product;
      }),
      usedPositiveOnly: usedPositiveOnly,
    };
  }

  function absoluteProductUrl(shopBase, productUrl) {
    if (!productUrl) return '';
    if (/^https?:\/\//i.test(productUrl)) return productUrl;
    return shopBase + productUrl;
  }

  function setProductAnchorNewTab(anchor) {
    if (!anchor) return;
    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('rel', 'noopener noreferrer');
  }

  /**
   * Beds list: primary = section "Beds collection". If empty, use products from the
   * mattresses collection that carry bedframe or sofabed (single-collection setups).
   */
  function getBedsCatalogCandidates(catalog) {
    var primary = Array.isArray(catalog.beds) ? catalog.beds : [];
    if (primary.length > 0) return primary;
    var mats = Array.isArray(catalog.mattresses) ? catalog.mattresses : [];
    var out = [];
    for (var i = 0; i < mats.length; i++) {
      var p = mats[i];
      var t = productTagsNormalized(p);
      if (t.indexOf('bedframe') !== -1 || t.indexOf('sofabed') !== -1) out.push(p);
    }
    return out;
  }

  /**
   * Mattresses list: primary = "Mattresses collection". If empty, use beds collection
   * products tagged mattress.
   */
  function getMattressCatalogCandidates(catalog) {
    var primary = Array.isArray(catalog.mattresses) ? catalog.mattresses : [];
    if (primary.length > 0) return primary;
    var beds = Array.isArray(catalog.beds) ? catalog.beds : [];
    var out = [];
    for (var i = 0; i < beds.length; i++) {
      var p = beds[i];
      var t = productTagsNormalized(p);
      if (t.indexOf('mattress') !== -1) out.push(p);
    }
    return out;
  }

  function init(root) {
    var cfgEl = root.querySelector('.bed-finder__config');
    var cfg = {};
    try {
      cfg = cfgEl && cfgEl.textContent ? JSON.parse(cfgEl.textContent) : {};
    } catch (e) {
      cfg = {};
    }
    var strings = cfg.strings || {};
    var Q = applyConfig(cloneQ(DEFAULT_Q), cfg);
    var shopUrl = (cfg.shopUrl || '').replace(/\/$/, '');

    var answers = {};
    var idx = 0;
    var done = false;
    var animKey = 0;
    var productTypeBaselineIdx = null;
    var productTypeBaselineJson = '';

    function checkmarkHtml(sel) {
      return (
        '<span class="bed-finder__check' +
        (sel ? ' bed-finder__check--on' : '') +
        '" aria-hidden="true"><svg class="bed-finder__check-svg" viewBox="0 0 16 16" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="bed-finder__check-path" d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'
      );
    }

    var progressEl = root.querySelector('.bed-finder__progress');
    var resultLabelEl = root.querySelector('.bed-finder__result-label');
    var mainEl = root.querySelector('.bed-finder__main');

    function flow() {
      return buildFlow(answers);
    }

    function renderProgress() {
      if (!progressEl) return;
      var f = flow();
      progressEl.innerHTML = '';
      for (var i = 0; i < f.length; i++) {
        var bar = document.createElement('div');
        bar.className = 'bed-finder__progress-bar';
        bar.setAttribute('aria-hidden', 'true');
        if (i === idx) {
          bar.classList.add('bed-finder__progress-bar--active');
        } else if (i < idx) {
          bar.classList.add('bed-finder__progress-bar--done');
        } else {
          bar.classList.add('bed-finder__progress-bar--todo');
        }
        progressEl.appendChild(bar);
      }
    }

    function summaryLines() {
      var lines = [];
      Object.keys(answers).forEach(function (k) {
        var v = answers[k];
        if (k === 'priorities') return;
        if (k === 'product_type') {
          var types = normalizeProductTypes(answers);
          if (types.length) {
            lines.push({
              label: 'Product type',
              value: types
                .map(function (t) {
                  return LABELS.product_type[t] || t;
                })
                .join(', '),
            });
          }
          return;
        }
        if (LABELS[k] && LABELS[k][v]) {
          lines.push({
            label: k.replace(/_/g, ' ').replace(/\b\w/g, function (c) {
              return c.toUpperCase();
            }),
            value: LABELS[k][v],
          });
        }
      });
      var prSummary = normalizePriorities(answers);
      if (prSummary.length) {
        var pl = prSummary
          .map(function (p) {
            return LABELS.priorities[p] || p;
          })
          .join(', ');
        lines.push({ label: strings.summaryPrioritiesLabel || 'Priorities', value: pl });
      }
      return lines;
    }

    function render() {
      var f = flow();
      var stepId = f[idx];
      var step = Q[stepId];
      var rec = done ? recommend(answers) : null;

      if (progressEl) {
        progressEl.hidden = done || strings.showProgress === false;
      }
      if (resultLabelEl) {
        resultLabelEl.hidden = !done;
      }

      mainEl.innerHTML = '';
      animKey += 1;

      if (!done && step) {
        if (stepId === 'product_type') {
          if (productTypeBaselineIdx !== idx) {
            productTypeBaselineIdx = idx;
            productTypeBaselineJson = JSON.stringify(normalizeProductTypes(answers).slice().sort());
          }
        }
        var wrap = document.createElement('div');
        wrap.className = 'bed-finder__step bed-finder__enter';
        wrap.setAttribute('data-anim', String(animKey));

        var numRow = document.createElement('div');
        numRow.className = 'bed-finder__step-num-row';
        var num = document.createElement('span');
        num.className = 'bed-finder__step-num';
        num.textContent = String(idx + 1).padStart(2, '0');
        num.setAttribute('aria-hidden', 'true');
        var rule = document.createElement('div');
        rule.className = 'bed-finder__step-rule';
        numRow.appendChild(num);
        numRow.appendChild(rule);
        wrap.appendChild(numRow);

        var h2 = document.createElement('h2');
        h2.className = 'bed-finder__question' + (step.hint ? ' bed-finder__question--tight' : '');
        h2.textContent = step.q;
        wrap.appendChild(h2);

        if (step.hint) {
          var hint = document.createElement('p');
          hint.className = 'bed-finder__hint';
          hint.textContent = step.hint;
          wrap.appendChild(hint);
        }

        if (stepId === 'budget' && answers.existing_mattress === 'yes_premium' && strings.budgetPremiumTitle) {
          var nw = document.createElement('div');
          nw.className = 'bed-finder__notice bed-finder__notice--accent';
          nw.innerHTML =
            '<p class="bed-finder__notice-title">' +
            esc(strings.budgetPremiumTitle) +
            '</p><p class="bed-finder__notice-body">' +
            esc(strings.budgetPremiumBody || '') +
            '</p>';
          wrap.appendChild(nw);
        }

        var opts = document.createElement('div');
        opts.className = 'bed-finder__options';
        step.options.forEach(function (opt) {
          var sel = answers[stepId] === opt.v;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bed-finder__opt' + (sel ? ' bed-finder__opt--selected' : '');
          btn.setAttribute('aria-pressed', sel ? 'true' : 'false');
          btn.innerHTML =
            '<span class="bed-finder__opt-inner"><span class="bed-finder__opt-text"><span class="bed-finder__opt-label">' +
            esc(opt.label) +
            '</span><span class="bed-finder__opt-sub">' +
            esc(opt.sub) +
            '</span></span>' +
            checkmarkHtml(sel) +
            '</span>';
          btn.addEventListener('click', function () {
            var na2 = Object.assign({}, answers);
            na2[stepId] = opt.v;
            answers = na2;
            render();
          });
          opts.appendChild(btn);
        });
        wrap.appendChild(opts);

        function canAdvanceStep() {
          return !!answers[stepId];
        }

        var nav = document.createElement('div');
        nav.className = 'bed-finder__nav';
        var prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'bed-finder__btn bed-finder__btn--secondary bed-finder__btn--nav';
        prevBtn.innerHTML = '<span class="bed-finder__nav-icon" aria-hidden="true">←</span> ' + esc(strings.labelPrevious || 'Previous');
        prevBtn.disabled = idx === 0;
        prevBtn.addEventListener('click', function () {
          if (idx === 0) return;
          idx -= 1;
          animKey += 1;
          render();
        });
        var nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'bed-finder__btn bed-finder__btn--primary bed-finder__btn--nav';
        var flowPreview = flow();
        var isLastStepUi = idx >= flowPreview.length - 1;
        var nextLabel = isLastStepUi ? strings.labelFinish || strings.labelNext || 'Next' : strings.labelNext || 'Next';
        nextBtn.innerHTML = esc(nextLabel) + ' <span class="bed-finder__nav-icon" aria-hidden="true">→</span>';
        nextBtn.disabled = !canAdvanceStep();
        nextBtn.addEventListener('click', function () {
          if (!canAdvanceStep()) return;
          var flowSteps = flow();
          var isLast = idx >= flowSteps.length - 1;

          if (stepId === 'product_type' && !isLast) {
            var nowPt = JSON.stringify(normalizeProductTypes(answers).slice().sort());
            if (nowPt !== productTypeBaselineJson) {
              wipeDownstreamOfProductType(answers);
            }
            productTypeBaselineIdx = null;
          }

          if (isLast) {
            done = true;
            render();
            return;
          }
          idx += 1;
          animKey += 1;
          render();
        });
        nav.appendChild(prevBtn);
        nav.appendChild(nextBtn);
        wrap.appendChild(nav);

        mainEl.appendChild(wrap);
      } else if (done && rec) {
        var rw = document.createElement('div');
        rw.className = 'bed-finder__result bed-finder__enter';

        var tagRow = document.createElement('div');
        tagRow.className = 'bed-finder__tag-row';
        tagRow.innerHTML =
          '<span class="bed-finder__tag-rule" aria-hidden="true"></span><span class="bed-finder__tag">' +
          esc(rec.tag) +
          '</span><span class="bed-finder__tag-rule bed-finder__tag-rule--grow" aria-hidden="true"></span>';
        rw.appendChild(tagRow);

        var h1 = document.createElement('h1');
        h1.className = 'bed-finder__headline';
        h1.textContent = rec.headline;
        rw.appendChild(h1);

        var desc = document.createElement('p');
        desc.className = 'bed-finder__desc';
        desc.textContent = rec.desc;
        rw.appendChild(desc);

        if (rec.exclusion === 'entry' && strings.resultExclusionTitle) {
          var n1 = document.createElement('div');
          n1.className = 'bed-finder__notice bed-finder__notice--accent';
          n1.innerHTML =
            '<p class="bed-finder__notice-title">' +
            esc(strings.resultExclusionTitle) +
            '</p><p class="bed-finder__notice-body">' +
            esc(strings.resultExclusionBody || '') +
            '</p>';
          rw.appendChild(n1);
        }

        if (rec.platformNote === 'premium' && strings.resultPlatformPremiumTitle) {
          var n2 = document.createElement('div');
          n2.className = 'bed-finder__notice bed-finder__notice--gold';
          n2.innerHTML =
            '<p class="bed-finder__notice-title">' +
            esc(strings.resultPlatformPremiumTitle) +
            '</p><p class="bed-finder__notice-body">' +
            esc(strings.resultPlatformPremiumBody || '') +
            '</p>';
          rw.appendChild(n2);
        }

        if (rec.platformNote === 'standard' && strings.resultPlatformStandardTitle) {
          var n3 = document.createElement('div');
          n3.className = 'bed-finder__notice bed-finder__notice--gold';
          n3.innerHTML =
            '<p class="bed-finder__notice-title">' +
            esc(strings.resultPlatformStandardTitle) +
            '</p><p class="bed-finder__notice-body">' +
            esc(strings.resultPlatformStandardBody || '') +
            '</p>';
          rw.appendChild(n3);
        }

        var catalog = cfg.catalog && typeof cfg.catalog === 'object' ? cfg.catalog : { beds: [], mattresses: [] };
        var qs = cfg.quizSettings || {};
        var maxPer = parseInt(qs.maxPerSection, 10);
        if (isNaN(maxPer) || maxPer < 1) maxPer = 6;
        var wantedTags = answersToQuizTags(answers);
        var ptTypes = normalizeProductTypes(answers);
        var showBedsSection =
          ptTypes.indexOf('frame') !== -1 || ptTypes.indexOf('help') !== -1 || ptTypes.indexOf('sofa') !== -1;
        var showMattSection = ptTypes.indexOf('mattress') !== -1;
        var bedsCatalog = getBedsCatalogCandidates(catalog);
        var matCatalog = getMattressCatalogCandidates(catalog);
        var rankBeds = showBedsSection ? rankProductsByTags(bedsCatalog, wantedTags, maxPer) : { ranked: [] };
        var rankMat = showMattSection ? rankProductsByTags(matCatalog, wantedTags, maxPer) : { ranked: [] };
        var bedHandleSeen = {};
        for (var bi = 0; bi < rankBeds.ranked.length; bi++) {
          if (rankBeds.ranked[bi].handle) bedHandleSeen[rankBeds.ranked[bi].handle] = true;
        }
        if (rankMat.ranked.length) {
          rankMat.ranked = rankMat.ranked.filter(function (p) {
            return !p.handle || !bedHandleSeen[p.handle];
          });
        }

        var picksWrap = document.createElement('div');
        picksWrap.className = 'bed-finder__picks';

        function appendPickSection(title, products, emptyMsg, fallbackUrl, fallbackLabel) {
          var sec = document.createElement('section');
          sec.className = 'bed-finder__pick-section';
          var h = document.createElement('h2');
          h.className = 'bed-finder__pick-title';
          h.textContent = title;
          sec.appendChild(h);
          if (products.length) {
            var grid = document.createElement('div');
            grid.className = 'bed-finder__pick-grid';
            for (var pi = 0; pi < products.length; pi++) {
              var p = products[pi];
              var card = document.createElement('article');
              card.className = 'bed-finder__card';
              var absUrl = absoluteProductUrl(shopUrl, p.url);
              var link = document.createElement('a');
              link.className = 'bed-finder__card-hit';
              link.href = absUrl;
              setProductAnchorNewTab(link);
              var media = document.createElement('div');
              media.className = 'bed-finder__card-media';
              if (p.image) {
                var img = document.createElement('img');
                img.className = 'bed-finder__card-img';
                img.src = p.image;
                img.alt = p.title || '';
                img.loading = 'lazy';
                img.decoding = 'async';
                media.appendChild(img);
              }
              link.appendChild(media);
              var body = document.createElement('div');
              body.className = 'bed-finder__card-body';
              var ttl = document.createElement('h3');
              ttl.className = 'bed-finder__card-name';
              ttl.textContent = p.title || '';
              body.appendChild(ttl);
              var subText = p.subtitle != null ? String(p.subtitle).trim() : '';
              if (subText) {
                var sub = document.createElement('p');
                sub.className = 'bed-finder__card-subtitle';
                sub.textContent = subText;
                body.appendChild(sub);
              }
              var priceRaw = p.price != null ? String(p.price).trim() : '';
              if (priceRaw) {
                var priceLine = document.createElement('p');
                priceLine.className = 'bed-finder__card-price';
                var priceLbl = document.createElement('span');
                priceLbl.className = 'bed-finder__card-price-label';
                priceLbl.textContent = (strings.startingFromLabel || 'Starting From:') + ' ';
                var priceVal = document.createElement('span');
                priceVal.className = 'bed-finder__card-price-value';
                priceVal.textContent = priceRaw;
                priceLine.appendChild(priceLbl);
                priceLine.appendChild(priceVal);
                body.appendChild(priceLine);
              }
              link.appendChild(body);
              card.appendChild(link);
              var cta = document.createElement('a');
              cta.className = 'bed-finder__btn bed-finder__btn--primary bed-finder__card-cta';
              cta.href = absUrl;
              setProductAnchorNewTab(cta);
              cta.textContent = strings.ctaProductDetails || 'View Product';
              card.appendChild(cta);
              grid.appendChild(card);
            }
            sec.appendChild(grid);
          } else {
            var empty = document.createElement('p');
            empty.className = 'bed-finder__pick-empty';
            empty.textContent = emptyMsg || '';
            sec.appendChild(empty);
            if (fallbackUrl) {
              var fa = document.createElement('a');
              fa.className = 'bed-finder__btn bed-finder__btn--primary bed-finder__btn--link bed-finder__pick-fallback';
              fa.href = absoluteProductUrl(shopUrl, fallbackUrl);
              fa.textContent = fallbackLabel || 'Browse';
              sec.appendChild(fa);
            }
          }
          picksWrap.appendChild(sec);
        }

        if (showBedsSection) {
          appendPickSection(
            strings.headingBeds || 'Beds',
            rankBeds.ranked,
            strings.emptyBeds || '',
            qs.fallbackBedCollectionUrl || '',
            strings.fallbackBrowseBeds || 'Browse all beds'
          );
        }
        if (showMattSection) {
          appendPickSection(
            strings.headingMattresses || 'Mattresses',
            rankMat.ranked,
            strings.emptyMattresses || '',
            qs.fallbackMattressCollectionUrl || '',
            strings.fallbackBrowseMattresses || 'Browse all mattresses'
          );
        }
        rw.appendChild(picksWrap);

        var btns = document.createElement('div');
        btns.className = 'bed-finder__actions bed-finder__actions--result';
        var restart = document.createElement('button');
        restart.type = 'button';
        restart.className = 'bed-finder__btn bed-finder__btn--secondary';
        restart.textContent = strings.ctaStartAgain || 'Start Again';
        restart.addEventListener('click', function () {
          answers = {};
          idx = 0;
          done = false;
          animKey += 1;
          productTypeBaselineIdx = null;
          productTypeBaselineJson = '';
          render();
        });
        btns.appendChild(restart);
        rw.appendChild(btns);

        var gr = document.createElement('div');
        gr.className = 'bed-finder__divider';
        gr.setAttribute('aria-hidden', 'true');
        rw.appendChild(gr);

        var sumTitle = document.createElement('p');
        sumTitle.className = 'bed-finder__summary-kicker';
        sumTitle.textContent = strings.summaryTitle || 'Customer Summary';
        rw.appendChild(sumTitle);
        var sumSub = document.createElement('p');
        sumSub.className = 'bed-finder__summary-sub';
        sumSub.textContent = strings.summarySubtitle || 'In-store and pre-call reference';
        rw.appendChild(sumSub);

        var grid = document.createElement('div');
        grid.className = 'bed-finder__summary-grid';
        summaryLines().forEach(function (l) {
          var cell = document.createElement('div');
          cell.className = 'bed-finder__summary-cell';
          cell.innerHTML =
            '<div class="bed-finder__summary-label">' +
            esc(l.label) +
            '</div><div class="bed-finder__summary-value">' +
            esc(l.value) +
            '</div>';
          grid.appendChild(cell);
        });
        rw.appendChild(grid);

        var foot = document.createElement('div');
        foot.className = 'bed-finder__footer-note';
        foot.innerHTML =
          '<span class="bed-finder__footer-accent" aria-hidden="true"></span><p class="bed-finder__footer-text">' +
          esc(strings.advisorNote || '') +
          '</p>';
        rw.appendChild(foot);

        mainEl.appendChild(rw);
      }

      renderProgress();
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-bed-finder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
